<template lang="pug">
  div(class="content")
    .md-layout.md-alignment-center-center
      div(class="md-layout-item md-size-33 md-medium-size-50 md-small-size-80")
        md-card
          md-card-header(data-background-color='green')
            md-card-header-text
              .md-title Analyst Group Materials
            md-card-media(md-big)
              md-icon.md-size-5x library_books
          md-card-actions
            a(:href='analystSource' target='_blank')
              md-button Go
      div(class="md-layout-item md-size-33 md-medium-size-50 md-small-size-80")
        md-card
          md-card-header(data-background-color='green')
            md-card-header-text
              .md-title General Materials
            md-card-media(md-big)
              md-icon.md-size-5x folder
          md-card-actions
            a(:href='generalSource' target='_blank')
              md-button Go
      div(class="md-layout-item md-size-33 md-medium-size-50 md-small-size-80")
        md-card
          md-card-header(data-background-color='green')
            md-card-header-text
              .md-title Fund Materials
            md-card-media(md-big)
              md-icon.md-size-5x folder
          md-card-actions
            a(:href='fundSource' target='_blank')
              md-button Go
    //- div(class="md-layout" style="height: 70vh;")
    //-   div(class="md-layout-item md-size-10 md-xsmall-size-100 centered")
    //-     md-button.md-raised(v-if="!notLoaded" :href="source" target="_blank") Open in New Window
    //-   div(v-if="notLoaded" class="md-layout-item md-size-100 centered")
    //-     loading
    //-   iframe(id="frame" :class="[{loading: notLoaded}, 'md-image']" @load="notLoaded = false" :src="source" width="97%" height="100%" frameborder="0")
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return{
      analystSource: 'https://usit.box.com/s/w0l7qg69b3tiseyslfaij9bcx6g1l0co',
      generalSource: 'https://usit.box.com/s/an0a1vj2hfv2tzxpsxeqv48a332f980r',
      fundSource: 'https://usit.box.com/s/r3szvy68cx79kz8x5uxdgrbx5spx5ehi',
      notLoaded: true,
    };
  }
}
</script>

<style scoped>
  .content {
    padding-top: 0px;
  }

  .centered {
    text-align: center;
  }

  .loading {
    display: none;
  }
</style>




// WEBPACK FOOTER //
// src/pages/Resources/Box.vue